const PlayIcon = () => {
  return (
    <svg
      width="34"
      height="37"
      viewBox="0 0 34 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        clipPath="url(#bgblur_0_15662_19083_clip_path)"
        data-figma-skip-parse="true"
      >
        <foreignObject x="0.25" y="0.867676" width="33.75" height="35.2646">
          <div
            style={{
              backdropFilter: 'blur(2px)',
              height: '100%',
              width: '100%',
            }}
          ></div>
        </foreignObject>
      </g>
      <g filter="url(#filter0_d_15662_19083)" data-figma-bg-blur-radius="4">
        <path
          d="M23 13.7679C24.3333 14.5377 24.3333 16.4623 23 17.2321L13.25 22.8612C11.9167 23.631 10.25 22.6688 10.25 21.1292L10.25 9.87084C10.25 8.33123 11.9167 7.36898 13.25 8.13878L23 13.7679Z"
          fill="white"
          fillOpacity="0.7"
          shapeRendering="crispEdges"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_15662_19083"
          x="0.25"
          y="0.867676"
          width="33.75"
          height="35.2646"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3" />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_15662_19083"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_15662_19083"
            result="shape"
          />
        </filter>
        <clipPath id="bgblur_0_15662_19083_clip_path">
          <path d="M23 13.7679C24.3333 14.5377 24.3333 16.4623 23 17.2321L13.25 22.8612C11.9167 23.631 10.25 22.6688 10.25 21.1292L10.25 9.87084C10.25 8.33123 11.9167 7.36898 13.25 8.13878L23 13.7679Z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PlayIcon;
